import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import {
  ADDRESS_BY_CHAIN_CRONOS_EVM,
  getRelatedCronosEvmChain,
} from '@cronos-app/sdk';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getFULToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.FUL,
    symbol: 'FUL',
    addressL1: sdks.L1.getContractAddress('FUL'),
    addressL2: sdks.L2.getContractAddress('FUL'),
    addressCronosEvm:
      ADDRESS_BY_CHAIN_CRONOS_EVM[getRelatedCronosEvmChain(desiredNetwork)].FUL,
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/ful.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="Fulcrom"
        {...props}
      />
    ),
  };
};
